import { AfterViewInit, Component, Inject, Input, QueryList, ViewChildren } from '@angular/core';
import { AbstractControl, FormControl } from '@angular/forms';
import { NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { APP_CONFIG } from '../../../app.config';
import { AssistantService } from '../../../common/assistant.service';
import { AppConfig } from '../../../models/config/app-config';

/**
 * This is a component which bundles a label, a an input field and and assistant template<br>
 * <app-input [fieldId]="'referenz.ansprechpartner.familienname'"
 * [type]="'text'"
 * [control]="form.get('familienname')"
 * [label]="'Familienname' | translate"
 * [toUpperCaseEnabled]="true"
 * [assistentServiceEnabled]="true"
 * [saveLastFocusedEnabled]="true"
 * [popOverName]="'popFamilienname'"
 * [assistantDTOs]="[{Application :'MEK', ApplicationForm : 'LANGFRISTIGER_AUFENTHALT', Text : 'test'},
 * {Application :'MEK', ApplicationForm : 'KURZFRISTIGER_AUFENTHALT', Text : 'test'},
 * {Application :'VIDEX', ApplicationForm : 'LANGFRISTIGER_AUFENTHALT', Text : 'test'},
 * {Application :'VIDEX', ApplicationForm : 'KURZFRISTIGER_AUFENTHALT', Text : 'test' | translate }]"></app-input>
 */
@Component({
  selector: 'app-input',
  templateUrl: './input.component.html',
  styleUrls: ['./input.component.scss']
})
export class InputComponent implements AfterViewInit {

  /**
   * The ID of the input field
   */
  @Input()
  fieldId: string;

  /**
   * The type of the input field
   */
  @Input()
  type: string;

  /**
   * The form control which is bound to this component
   */
  @Input()
  control: AbstractControl;

  /**
   * The text of the label
   */
  @Input()
  label: string;

  /**
   * Flag to determine whether the last focused field should be saved for the assistant service
   */
  @Input()
  saveLastFocusedEnabled: boolean;

  /**
   * Flag to determine whether the input field should transform the entered content to upper case
   */
  @Input()
  toUpperCaseEnabled: boolean;

  /**
   * Flag to determine whether the assistent service is enabled
   */
  @Input()
  assistantServiceEnabled: boolean;

  /**
   * The name of the pop over to apply the assistant service
   */
  @Input()
  popOverName: string;

  /**
   * A list of all occurrences of the 'ngbPopover' property of the host view
   */
  @ViewChildren(NgbPopover)
  private assistantPopoverList: QueryList<NgbPopover>;

  /**
   * Constructor
   * @param assistantService for further field information
   * @param appConfig configuration of the application
   */
  constructor(private assistantService: AssistantService,
              @Inject(APP_CONFIG) public appConfig: AppConfig) {
  }

  /**
   * This method verifies whether this input field is mandatory or not based on the validators of this control
   */
  isMandatory(): boolean {
    if (this.control && this.control.validator) {
      const validator = this.control.validator({} as AbstractControl);
      if (validator && validator.required) {
        return true;
      }
    }
    return false;
  }

  /**
   * This method returns the max length of the input field based on the validators of this control
   */
  getMaxLength(): number {
    if (this.control && this.control.validator) {
      const fc = new FormControl();
      fc.setValue('');
      const errors = this.control.validator(fc);
      if (errors && errors.maxlength && errors.maxlength.requiredLength) {
        return errors.maxlength.requiredLength;
      }
    }
    return 5000;
  }

  /**
   *  This method verifies whether the content of the input field is valid or not
   */
  isInvalid(): boolean {
    return !!this.control && (this.control.dirty || this.control.touched) && this.control.errors != null;
  }

  /**
   * This method disables the assistant service if currently active
   */
  disableAssistant() {
    this.assistantService.disable();
  }

  ngAfterViewInit(): void {
    this.assistantService.initializeAssistant(this.assistantPopoverList);
  }
}
